var _defs, _polygon, _polygon2, _polygon3, _polyline, _polygon4, _polyline2, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _line, _polygon10, _polygon11, _polygon12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorPilotStuntPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pilot",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2dbd3;}.cls-2{fill:#6982af;}.cls-3{fill:#4668a3;}.cls-4{fill:#7699c4;}.cls-5{fill:#bc5e5e;}.cls-6{fill:#fff5eb;}.cls-7{fill:#7a94ce;}.cls-8{fill:#d0e3f7;}.cls-9{fill:#f7edef;}.cls-10{fill:#898881;opacity:0.3;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "482.53 1437.49 465.78 1442.12 429.7 1368.82 372.18 1140.97 428.81 1056.86 482.53 1437.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "571.46 1436.89 588.22 1441.52 624.29 1368.22 681.82 1140.37 625.18 1056.25 571.46 1436.89"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "355.66 1863.68 380.8 1765.19 528.21 1687.81 672.7 1763.15 702.38 1863.68 355.66 1863.68"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "613.56 1731.74 673.48 1764.01 677.72 1778.85 622.04 1764.99"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "616.96 1863.68 441.09 1863.68 466.21 1710.42 591.83 1710.42 616.96 1863.68"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "440.16 1733.39 380.24 1765.66 376 1780.5 431.67 1766.64"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "408.42 1700.37 461.19 1719.55 604.4 1716.65 644.49 1690.32 654.64 1743.09 637.06 1778.26 529.02 1795.85 420.99 1778.26 400.61 1743.09 408.42 1700.37"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "549.12 1436.57 527.77 1441.59 506.41 1436.57 501.38 1413.95 527.77 1406.42 554.15 1413.95 549.12 1436.57"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "644.84 1436.38 528.93 1405.05 413.02 1436.38 350.36 1635.87 406.81 1720.33 455.85 1730.76 602.01 1730.76 651.05 1720.33 707.5 1635.87 644.84 1436.38"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "413.02 1436.38 350.36 1635.87 371.8 1535.98 366.62 1461.72 413.02 1436.38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "644.75 1437.39 707.41 1636.87 685.97 1536.98 691.15 1462.73 644.75 1437.39"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 643.69,
    y1: 1438.26,
    x2: 527.77,
    y2: 1406.93
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "549.57 1430.77 528.21 1435.79 506.85 1430.77 501.83 1403.08 528.21 1395.54 554.59 1403.08 549.57 1430.77"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "820.97 2127 237.03 2127 205 1723.7 311.75 1570.95 746.25 1570.95 853 1723.7 820.97 2127"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "725.15 2098.1 332.85 2098.1 302.85 1723.03 340.36 1673.03 714.5 1673.03 755.15 1723.03 725.15 2098.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPilotStuntPilot);
export default __webpack_public_path__ + "static/media/interior-pilot-stunt-pilot.ccca09336d27a1dc50743826b1b365f1.svg";
export { ForwardRef as ReactComponent };